var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockHeading1React(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.74951 5h-5v-5h-3.74999828v15h3.74999828v-6.25h5v6.25h3.74999v-15h-3.74999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9794 6.27344h-2.1818l-2.1477 1.3125v2.01136l1.9091-1.14204h.0511v6.54544h2.3693z"
  }))));
}
export default SvgBlockHeading1React;